import { MutationTree } from "vuex";
import { AuthState, User } from "../types";

const mutations: MutationTree<AuthState> = {
  setAuthenticated(state, isAuthenticated: boolean) {
    state.isAuthenticated = isAuthenticated;
  },
  setVerifyEmail(state, email: string) {
    state.verifyEmail = email;
  },
  setToken(state, token: string) {
    state.token = token;
  },
  setUser(state, user: User) {
    state.user = user;
  },
  setRefreshToken(state, refreshToken: string) {
    state.refreshToken = refreshToken;
  },
  setExpires(state, expires: string | number) {
    state.expires = expires;
  },
};

export default mutations;
